export const ColumnsIP = [
    { header: "Group", key: "group" },
    { header: "IP address", key: "ip" },
  ];